export const awards = {
	title: "Premios",
	description:
		"Seleccione los productos y los descuentos a los que el cliente tendrá derecho.",
	maxUses: {
		label: "Cantidad máxima de usos por ganancia",
		withoutLimits: "Sin límites",
	},
	discountType: {
		label: "Tipo del descuento",
		percentage: "Porcentaje",
		value: "Valor",
		error: "Los siguientes productos tienen valor menor que el descuento dado",
		table: {
			product: "Producto",
			price: "Valor de venta",
			promotionalPrice: "Valor promocional",
			error: "Valor máximo y mínimo no corresponde",
			empty: {
				label: "Ningún producto seleccionado",
				description:
					"Si no selecciona productos, la promoción funcionará en todos los productos.",
			},
			total: "Total de {{count}} producto(s)",
			add: "Agregar productos",
		},
	},
};
